import React from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Paper
} from '@mui/material';
import {
  Assessment as AssessmentIcon,
  Inventory as InventoryIcon
} from '@mui/icons-material';

const Informes: React.FC = () => {
  const navigate = useNavigate();

  const informes = [
    {
      title: 'Stock por Depósito',
      description: 'Visualice el stock de productos por cada depósito',
      icon: <InventoryIcon sx={{ fontSize: 40 }} />,
      path: 'stock-deposito'
    },
    {
      title: 'Movimientos de Stock',
      description: 'Consulte el historial de movimientos de stock',
      icon: <AssessmentIcon sx={{ fontSize: 40 }} />,
      path: 'movimientos-stock'
    }
  ];

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <Card 
        sx={{ 
          bgcolor: '#ffffff',
          borderRadius: 3,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          overflow: 'hidden'
        }}
      >
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Typography 
            variant="h4" 
            sx={{ 
              mb: 3,
              fontWeight: 600,
              color: '#1976d2'
            }}
          >
            Informes de Inventario
          </Typography>
          
          <Grid container spacing={3}>
            {informes.map((informe) => (
              <Grid item xs={12} sm={6} md={4} key={informe.path}>
                <Card
                  sx={{
                    borderRadius: 3,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    '&:hover': {
                      boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                      transform: 'translateY(-4px)',
                    }
                  }}
                >
                  <CardActionArea onClick={() => navigate(informe.path)}>
                    <CardContent sx={{ p: 3 }}>
                      <Box display="flex" alignItems="center" mb={2}>
                        <Box
                          sx={{
                            bgcolor: '#1976d2',
                            color: '#fff',
                            borderRadius: 2,
                            p: 1.5,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mr: 2
                          }}
                        >
                          {informe.icon}
                        </Box>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          {informe.title}
                        </Typography>
                      </Box>
                      <Typography color="textSecondary" sx={{ mt: 1 }}>
                        {informe.description}
                      </Typography>
                      <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', color: '#1976d2' }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          Ver informe
                        </Typography>
                        <Box sx={{ ml: 1, transform: 'translateX(0)', transition: 'transform 0.2s' }}>
                          →
                        </Box>
                      </Box>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>

      <Outlet />
    </Box>
  );
};

export default Informes;
